import { FormValidationService, FormValidity } from './form-validation.service';
import { Observable, Subject } from 'rxjs';
import { map, merge } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { NotificationService } from './notification.service';

@Injectable()
export class StudentProfileButtonService {

  disablePrevButton$: Observable<boolean>;
  disableNextButton$: Observable<boolean>;
  disableCompleteButton$: Observable<boolean>;

  prevEmitter = new Subject<boolean>();
  nextEmitter = new Subject<boolean>();
  completeEmitter = new Subject<boolean>();

  isPrevDisabled = true;
  isNextDisabled = false;

  private disablePrev = new Subject<boolean>();
  private disableNext = new Subject<boolean>();

  private disableComplete = new Subject<boolean>();

  private nextHandler: Function;

  constructor(
    private notificationService: NotificationService,
    private formValidationService: FormValidationService
  ) {
    this.disableNextButton$ = this.formValidationService.formsValidity$.pipe(map((validity: FormValidity) => !validity.isValid), merge(this.disableNext));
    this.disableCompleteButton$ = this.formValidationService.formsValidity$.pipe(map((validity: FormValidity) => !validity.isValid), merge(this.disableComplete));
    this.disablePrevButton$ = this.disablePrev.asObservable();
    this.disableNextButton$.subscribe((isDisabled: boolean) => {
      this.isNextDisabled = isDisabled;
    });
  }

  disableButtons() {
    this.disablePrev.next(true);
    this.disableNext.next(true);
    this.disableComplete.next(true);
  }

  enableButtons() {
    this.disablePrev.next(false);
    this.disableNext.next(false);
    this.disableComplete.next(false);
  }

  registerNextHandler(next: Function) {
    this.nextHandler = next;
  }

  executeNextHandler() {
    if (this.nextHandler && typeof (this.nextHandler) === 'function') {
      this.nextHandler();
      this.nextHandler = null;
    }
  }

  onNextClick() {
    this.formValidationService.touchForms.emit();
    if (this.isNextDisabled) {
      if (this.formValidationService['formsList'].emailForm.status === 'INVALID') {
        this.notificationService.show(
          'error',
          'please Enter valid email'
        );
      } else if (this.formValidationService['formsList'].addressForm.controls.zipCode.errors && !this.formValidationService['formsList'].addressForm.controls.zipCode.errors.required) {
        this.notificationService.show(
          'error',
          'please Enter valid zip code of 5 digit'
        );
      } else if (this.formValidationService['formsList'].phoneForm.controls.primaryPhone.errors) {
        this.notificationService.show(
          'error',
          'please Enter valid Phone of 10 digits'
        );
      } else if (this.formValidationService['formsList'].identityCard.controls.firstName.errors && !this.formValidationService['formsList'].identityCard.controls.firstName.errors.required) {
        this.notificationService.show(
          'error',
          'Please enter firstName at least 2 characters to proceed'
        );
      } else if (this.formValidationService['formsList'].identityCard.controls.lastName.errors && !this.formValidationService['formsList'].identityCard.controls.lastName.errors.required) { 
        this.notificationService.show(
          'error',
          'Please enter lastName at least 2 characters to proceed'
        );
      } else {
        this.notificationService.show(
          'error',
          'please fill all the required fields'
        );
      }
     
      return;
    }
    this.nextEmitter.next();
  }

  onPrevClick() {
    this.prevEmitter.next();
  }

  onCompleteClick() {
    this.completeEmitter.next();
  }

}
